import { render } from "./Procurement.vue?vue&type=template&id=858071ba&scoped=true"
import script from "./Procurement.vue?vue&type=script&lang=js"
export * from "./Procurement.vue?vue&type=script&lang=js"

import "./Procurement.vue?vue&type=style&index=0&id=858071ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-858071ba"]])

export default __exports__